import './index.css';
import React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App.tsx';

export default App;

ReactDOM.createRoot(document.getElementById("cmrwcovc50003rh0z3tumtkov-root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
